const modifiedEnv = (name, separator, add) => {
  const splitName = name.split(separator);
  return `${splitName[0]}/${add}/${splitName[1]}`;
};

export default modifiedEnv;
